import {getMethod} from '~/api'

async function get(productTypeName) {
    return await getMethod(`/api/priceListCalculationTypes/${productTypeName}`)
}

export {get}
